/* ==========================================================================
   Input — Vapt Menu Design System
   Text input with label, error, hint; password toggle; react-hook-form ready
   ========================================================================== */

.wrapper {
  display: flex;
  flex-direction: column;
  gap: var(--space-1);
}

.label {
  font-family: var(--font-body);
  font-size: var(--text-body-sm-size);
  font-weight: 500;
  color: var(--color-text-primary);
}

.required {
  color: var(--color-error);
  margin-left: 2px;
}

.inputWrapper {
  position: relative;
  display: flex;
  align-items: center;
}

.input {
  width: 100%;
  height: 44px;
  padding: 0 var(--space-3);
  font-family: var(--font-body);
  font-size: var(--text-body-size);
  color: var(--color-text-primary);
  background-color: var(--color-surface);
  border: 1.5px solid var(--color-border);
  border-radius: var(--radius-sm);
  transition:
    border-color var(--transition-fast),
    box-shadow var(--transition-fast);
}

.input::placeholder {
  color: var(--color-text-secondary);
  opacity: 0.6;
}

.input:hover:not(:disabled):not(:focus) {
  border-color: var(--color-text-secondary);
}

.input:focus {
  outline: none;
  border-color: var(--color-primary);
  box-shadow: var(--focus-ring-primary);
}

.input:disabled {
  opacity: 0.5;
  cursor: not-allowed;
  background-color: var(--color-surface-alt);
}

/* Password toggle padding */
.hasTrailing {
  padding-right: 44px;
}

/* --- Error state --- */

.error .input {
  border-color: var(--color-error);
}

.error .input:focus {
  box-shadow: var(--focus-ring-error);
}

.error .label {
  color: var(--color-error);
}

/* --- Messages --- */

.hint {
  font-size: var(--text-label-size);
  color: var(--color-text-secondary);
}

.errorMessage {
  font-size: var(--text-label-size);
  color: var(--color-error);
}

/* --- Toggle password button --- */

.toggleBtn {
  position: absolute;
  right: var(--space-2);
  display: flex;
  align-items: center;
  justify-content: center;
  width: 32px;
  height: 32px;
  padding: 0;
  border: none;
  background: none;
  color: var(--color-text-secondary);
  cursor: pointer;
  border-radius: var(--radius-sm);
  transition: color var(--transition-fast);
}

.toggleBtn:hover {
  color: var(--color-text-primary);
}

.toggleBtn:focus-visible {
  outline: 2px solid var(--color-focus);
  outline-offset: 2px;
}
